import React, { useState } from 'react';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  selectAppLeftDrawerDisplay,
} from './settingsSlice';

export function Settings() {
  const appLeftDrawerDisplay = useAppSelector(selectAppLeftDrawerDisplay);
  const dispatch = useAppDispatch();


  return (
    <div>
      <div>
		  Settings
      </div>
    </div>
  );
}
